import React, { useEffect } from "react";   
import { ContactReferenceModel, PurchasePaymentIntentModel } from "../models";
import { FlexContainer } from "@mindmemobile/mm-shared-global";
import styled from "styled-components";

type PaymentFormProps = {
  paymentIntent: PurchasePaymentIntentModel | null;
  onPaymentSuccess: (token: string) => void;
  onPaymentError: () => void;
  contact: ContactReferenceModel | null;
};

const PaymentFormWrapper = styled(FlexContainer)`
&.multiple-payment-method-form-latest{
    .payment-form{
        margin: 0 -24px;
    }
    .default-payment-form{
        margin: 0px;
    }
}
`

declare global {
  interface Window {
      Forward: any;
  }
}

let unmountPaymentElement: any;
const PaymentForm: React.FC<PaymentFormProps> = ({ paymentIntent, onPaymentSuccess, onPaymentError, contact }) => {
  useEffect(() => {
      if (window.Forward) {
          renderPaymentForm();
      } else {
          console.error('Payment form cannot be rendered: missing clientSecret or Forward library not loaded.');
      }

      return () => {
          unmountPaymentElement && unmountPaymentElement();
      };
  }, []);

  async function getPaymentElement() {
      return (
          typeof window !== 'undefined' &&
          window.Forward.createPaymentElement({
              apiKey: process.env.REACT_APP_FISERV_API_KEY,
              clientSecret: paymentIntent?.clientSecret,
          })
      );
  }

  async function renderPaymentForm() {
      const paymentElement = await getPaymentElement();

      unmountPaymentElement = paymentElement.mount('#payment-form', {
          onChange: (event: any) => {
              if (!event.ready) {
                  console.log('Credit card input is incomplete');
              }
              onPaymentError();
          },
          onReady: (tokenize: any) => {
              tokenize();
              document.getElementById('pay-button')?.addEventListener('click', () => {
                  const email = contact?.email;
                  const fullName = `${contact?.firstName || ''} ${contact?.lastName || ''}`;
                  tokenize({
                      billingDetails: {
                          address: { email: email, name: fullName },
                      },
                  });
              });
              onPaymentError();
          },
          onSuccess: async ({ token }: any) => {
              onPaymentSuccess(token);
          },
          onError: () => {
              onPaymentError();
          },
      });
  }

  return (
      <PaymentFormWrapper className={
        paymentIntent?.hasMultiplePaymentMethods()
            ? 'multiple-payment-method-form-latest'
            : 'default-payment-method-form-latest'
    } >
          <div id="payment-form" className="payment-form" />
      </PaymentFormWrapper>
  );
};

export default PaymentForm;
